import React, { type MouseEvent } from 'react';
import { Box } from '@atlaskit/primitives';
import type { ExternalAction } from '@atlassian/jira-issue-view-store/src/actions/external-actions';
import {
	MentionsIndicator,
	UNREAD_MENTIONS_INDICATOR_WRAPPER_TEST_ID,
} from '@atlassian/jira-mentions-indicator';
import type { Mentions } from '../../../common/types';

type Props = {
	unreadMentions: Mentions | null;
	onClick: (arg1: MouseEvent<HTMLElement>, arg2?: ExternalAction) => void;
};

export default function MentionsIndicatorField({ unreadMentions, onClick }: Props) {
	if (
		!unreadMentions ||
		(!unreadMentions.hasUnreadIssueDescriptionMention &&
			unreadMentions.latestUnreadCommentId === null)
	) {
		return null;
	}

	return unreadMentions.latestUnreadCommentId ? (
		<Box testId={UNREAD_MENTIONS_INDICATOR_WRAPPER_TEST_ID}>
			<MentionsIndicator
				onClick={(e) =>
					onClick(e, {
						type: 'SCROLL_TO_COMMENT',
						payload: {
							// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
							commentId: unreadMentions.latestUnreadCommentId!,
						},
					})
				}
			/>
		</Box>
	) : (
		<Box testId={UNREAD_MENTIONS_INDICATOR_WRAPPER_TEST_ID}>
			<MentionsIndicator onClick={onClick} />
		</Box>
	);
}
